import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { nullSafe } from 'Utility/globalMethods';
import { portalModalSelector, getRegister } from 'Store/selectors';
import { goPopup } from 'Store/actions/portalModalActions';
import * as actionLayer from '../../modules/RegisterActions';
import DeleteRegisterPopup from './DeleteRegisterPopup';

const mapDispatchToProps = (dispatch) => ({
	deleteRegister: (registerId) =>
		dispatch(
			actionLayer.deleteRegister.request({
				...registerId,
			})
		),
	closeModal: () => dispatch(goPopup('')),
	...bindActionCreators(actionLayer, dispatch),
});

const mapStateToProps = (state) => ({
	isLoading: nullSafe(() => getRegister(state, 'isLoading'), false),
	payload: nullSafe(() => portalModalSelector(state).data.payload, false),
});

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps) => ({
	...stateProps,
	actions: dispatchProps,
}))(DeleteRegisterPopup);
